import { createReducer, on } from '@ngrx/store';
import { BasicInfo, UserStats } from "../../modals/user.stats"
import * as UserStatsActions from "./user.stats.action";

export type StatsState = {
    recognitionKinectionSent: number;
    rank: string;
    totalUsers: string;
    companyLeader: BasicInfo;
    runnerUp: BasicInfo;
    comingUp: BasicInfo;
    statsLoaded: boolean;
}

export const initialStatsState: StatsState = {
    recognitionKinectionSent: 0,
    rank: '--',
    totalUsers: '--',
    companyLeader: null,
    runnerUp: null,
    comingUp: null,
    statsLoaded: false
}

const _statsReducer = createReducer(
    initialStatsState,
    on(UserStatsActions.userStatsLoaded, (state, { stats, statsLoaded }) => {
        return { ...stats, statsLoaded: true };
    }),
    on(UserStatsActions.userStatsLoadingError, (state, { errorMessage }) => {
        return { ...state, statsLoaded: false };
    }),
    on(UserStatsActions.userStatsResetCompleted, (state, { stats }) => {
        return { ...stats, statsLoaded: true };
    })
);

export function statsReducer(state: StatsState | undefined, action: any): StatsState {
    return _statsReducer(state, action);
}